/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const PetHealthContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 32px 40px 8px 40px;
  padding: 16px;
  background: ${props => (props.$isMadPawsStore ? 'var(--primary-light-6x)' : 'var(--grey-04)')};
  border-radius: 8px;
  line-height; 22.4px;
  & > svg {
    overflow: visible !important;
    margin-right: 16px;
  }
  @media screen and (max-width: 992px) {
    padding: 16px; 
    margin: 32px 24px 8px 24px;
  }
  `;

export const AutoShipBtnContainer = styled.div`
  button {
    margin-top: 10px;
    white-space: ${props => (props.$isMobile ? 'break-spaces' : 'nowrap')};
  }
`;

export const RecommendationContainer = styled.div`
  ${props =>
    props.$hideSWidget
      ? 'margin-bottom: 170px;  @media screen and (max-width: 992px) { margin-bottom: 151px;} @media screen and (max-width: 400px) {margin-bottom: 163px;}'
      : 'margin-bottom: 330px;'};
`;

export const OGOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > label {
    margin: 10px 0;
  }
`;

export const AddToCartContainer = styled.div`
  position: relative;
  flex: 1;
`;
